// Class for wrapping all available tracking categories.
export class CategoryMap {
	constructor(categories) {
		this.categories = categories;
	}

	getCategory(category) {
		if (this.hasCategory(category))
			return this.categories[category];
		console.warn('Category "' + category + '" has not been declared.');
		return null;
	}

	hasCategory(category) {
		return category in this.categories;
	}
}

// Individual tracking category.
export class Category {
	constructor(title, actions) {
		this.title = title;
		this.actions = actions;
	}

	getTitle() {
		return this.title;
	}

	getAction(action) {
		if (this.hasAction(action))
			return this.actions[action];
		console.warn('Action "' + action + '" does not exist in category "' + this.title + '"');
		return null;
	}

	getActionTypes() {
		return Object.keys(this.actions);
	}

	hasAction(action) {
		return action in this.actions;
	}
}